export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
  TUTOR = 'TUTOR',
  STUDENT = 'STUDENT',
  PARENT = 'PARENT',
}

export const ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'Super Administrador',
  [UserRole.ADMIN]: 'Administrador',
  [UserRole.TEACHER]: 'Docente',
  [UserRole.TUTOR]: 'Tutor/a',
  [UserRole.STUDENT]: 'Estudiante',
  [UserRole.PARENT]: 'Padre/Tutor',
}
